// ========== Imports ==========
import { dateFormat } from 'helpers/StringNumberFunction/formatDate';
import { amtStr } from 'helpers/StringNumberFunction/numFormatter';

// ========== Component ==========
export const ELetterServiceCosting = ({
  docType,
  previewDetail,
  allpreviewDetail,
  getCompany,
  getJournalEntry,
  paramVal,
  getGlCostCentre,
}) => {
  const getCostCentreDetails = costCentreID => {
    if (!costCentreID || !getGlCostCentre || getGlCostCentre.length === 0) {
      return { code: '-', name: '-' };
    }

    const costCentre = getGlCostCentre.find(cc => cc.ID === costCentreID);
    return {
      code: costCentre?.Code || '-',
      name: costCentre?.Name || '-',
    };
  };

  const journalEntry =
    getJournalEntry && getJournalEntry.length > 0
      ? getJournalEntry[0] // If it's an array with data, use first item
      : previewDetail; // Otherwise use previewDetail

  const detailItems = journalEntry?.costAdjustmentDetail || [];

  console.log('=== ELetterServiceCosting Debug ===');
  console.log('journalEntry:', journalEntry);
  console.log('detailItems:', detailItems);

  // ========== Document Type Processing ==========
  switch (docType) {
    case 'journal-entry':
      const result = Object.assign(paramVal, {
        // ==========================
        // COMPANY DETAILS
        // ==========================
        '[companyName]': getCompany?.[0]?.Name || '',
        '[companyRegNo]': getCompany?.[0]?.CompanyRegNo || '',
        '[companyAddress]': getCompany?.[0]?.Address?.address || '',
        '[companyContactNo]': getCompany?.[0]?.ContactNo || '',

        // ==========================
        // DOCUMENT DETAILS
        // ==========================
        '[docNo]': journalEntry?.docNo || '',
        '[docRef]': journalEntry?.docRef || '',
        '[description]': journalEntry?.description || '',
        '[docDate]': journalEntry?.docDate
          ? dateFormat(journalEntry.docDate)
          : '',
        '[transactionDate]': journalEntry?.transactionDate
          ? dateFormat(journalEntry.transactionDate)
          : '',
        '[docAmt]':
          journalEntry?.docAmt != null ? amtStr(journalEntry.docAmt) : '0.00',

        // ==========================
        // AUDIT/APPROVAL DETAILS
        // ==========================
        '[createdDate]': journalEntry?.auditLog?.createdTs
          ? dateFormat(journalEntry.auditLog.createdTs)
          : '',
        '[preparedBy]': journalEntry?.auditLog?.createdName || '',
        '[approvedBy]': journalEntry?.auditLog?.modName || '',
        '[approvedDate]': journalEntry?.auditLog?.modTs
          ? dateFormat(journalEntry.auditLog.modTs)
          : '',

        // ==========================
        // DETAIL LINE ITEMS
        // ==========================
        items:
          detailItems?.map((el, i) => {
            const indexValue = i + 1;

            // Get the cost centre details using the costCentreID
            const costCentreDetails = getCostCentreDetails(el?.costCentreID);

            return {
              '[index]': indexValue,
              '[contractTitle]': el?.contract?.title || '-',
              '[wbsName]': el?.wbs
                ? el.wbs.parentName
                  ? `${el.wbs.parentName} / ${el.wbs.name}`
                  : el.wbs.name
                : '-',
              '[costCategory]': el?.costCategory?.name || '-',
              '[itemName]': el?.costItem?.name || '-',

              '[debitAmt]': el?.docAmt > 0 ? amtStr(el.docAmt) : '0.00',
              '[creditAmt]': el?.docAmt < 0 ? amtStr(el.docAmt) : '0.00',

              '[glAccountCode]': el?.costCategory?.glAccountCode || '-',
              '[departmentCode]': costCentreDetails.code,
              '[deptCodeName]': costCentreDetails.name,
              '[remarks]': el?.remarks || '',
            };
          }) || [],

        '[sumDebitAmt]':
          journalEntry?.debitAmt != null
            ? amtStr(journalEntry.debitAmt)
            : '0.00',
        '[sumCreditAmt]':
          journalEntry?.creditAmt != null
            ? amtStr(journalEntry.creditAmt)
            : '0.00',
      });
  }
};
